import { render, staticRenderFns } from "./opening_hours.vue?vue&type=template&id=6be65108&"
import script from "./opening_hours.vue?vue&type=script&lang=js&"
export * from "./opening_hours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports